import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import SelectLogoColor from 'admin/views/site-designer/modules/sections/customize-logo-modal/select-color';
import Radio from 'common/components/elements/inputs/radio';

const IconSvgConvert = ({
   settings,
   fontList,
   setSettings,
   colors,
   onSelectFont,
   text,
   isMobile,
}) => {
   return (
      <>
         <SelectLogoColor
            colors={ colors }
            onSelect={ (color, isCustom) => {
               let colors = {}
               if(isCustom) {
                  colors = { custom_color: color }
               }
               setSettings({
                  ...settings,
                  color: color,
                  ...colors,
               }) } }
            customColor={ settings.custom_color ||  '#F8F9FA' }
            activeColor={ settings.color }
            id='logo_text'
            label='Color'
            isMobile={ isMobile }
         />
         <span className='leading-[20px] text-base text-major font-medium mb-2'>Font type</span>

         <div
            className='overflow-y-auto flex-1 py-1 flex flex-col border border-divider rounded-lg ams-custom-scrool'>
            {
               fontList.map(item => {
                  return (
                     <LogoItem
                        item={ item }
                        settings={ settings }
                        onSelectFont={ onSelectFont }
                        text={ text }
                     />
                  )
               })
            }
         </div>
      </>
   )
}

const LogoItem = ({
   item,
   settings,
   onSelectFont,
   text,
}) => {
   const itemRef = useRef(null);
   useEffect(() => {
      if(itemRef.current){
         const svg = itemRef.current.querySelectorAll('svg')[0];
         const textNode = itemRef.current.querySelectorAll('text')[0];
         getfontSize(itemRef.current)
         // const size = textNode.getAttribute('font-size')
         const bbox = textNode.getBoundingClientRect();
         svg.setAttribute("width", bbox.width + "px");
         svg.setAttribute("height", 56 + "px");
      }

   }, [itemRef])
   function getfontSize(element){
      if(!element) {
         return
      }
      element.style.margin = '0 auto'
      const maxWidth = 232
      const fontSize = 70
      var minFontSize = 20;
      const textSvg = element.querySelectorAll('text')[0]
      textSvg.setAttributeNS(null, 'font-size',  `${ fontSize }px`)
      var width = textSvg.getBoundingClientRect().width;
      textSvg.getBoundingClientRect()
      if(width > maxWidth) {
         var newfontSize = fontSize;
         var decrement = 1;
         var newWidth;
         while(width > maxWidth) {
            newfontSize -= decrement;
            if(newfontSize < minFontSize) {
               return { fontSize: `${ minFontSize }px` };
            }
            textSvg.setAttributeNS(null, 'font-size',  `${ Math.round(newfontSize) }px`)
            newWidth = textSvg.getBoundingClientRect().width;
            if(newWidth < maxWidth && decrement === 1){
               decrement = 0.1;
               newfontSize += 1;
            } else {
               width = newWidth;
            }
         }
         textSvg.setAttributeNS(null, 'font-size',  `${ Math.round(newfontSize) }px`)
      } else {
         textSvg.setAttributeNS(null, 'font-size',  `${ fontSize }px`)
      }
   }
   return (
      <div
         ref={ itemRef }
         onClick={ (e) => {
            const svg = e.currentTarget.querySelectorAll('svg')[0];
            const textNode = e.currentTarget.querySelectorAll('text')[0];
            getfontSize(e.currentTarget)
            const size = textNode.getAttribute('font-size')
            const bbox = textNode.getBoundingClientRect();
            svg.setAttribute("width", bbox.width + "px");
            svg.setAttribute("height", 56 + "px");
            onSelectFont({ ...item, logo_font_size: size, width: Math.round(bbox.width) }, text)
         } }
         role='presentation'
         key={ item.value.toString() }
         className='flex flex-col cursor-pointer w-full hover:bg-hover px-4 py-[10px]'
      >
         <div className='flex w-full justify-between'>
            <div className='flex flex-col'>
               <span className='leading-[20px] text-base text-major'> {item.name}</span>
               <svg
                  id={ settings.font_name === item.name  ? 'site-main-logo' : '' }
                  xmlns='http://www.w3.org/2000/svg'
                  height='56'
                  width='232'
                  viewBox='0 0 100 100'
                  style={ {
                     fontFamily: item.font,
                  } }
                  fontFamily={ item.font }
               >
                  <text
                     x='50'
                     y='50'
                     dx={ 0 }
                     dy={ settings.dy }
                     fill={ settings.color }
                     style={ {
                        fontFamily: item.font,
                     } }
                     fontFamily={ item.font }
                     fontSize={ item.logo_font_size }
                     textAnchor='middle'
                     dominantBaseline='central'
                  >
                     {text}
                  </text>
               </svg>
            </div>
            <Radio
               onChange={ _ => {} }
               checked={ settings.font_name === item.name }
            />

         </div>
      </div>
   )
}

IconSvgConvert.propTypes = {
   settings: PropTypes.object,
   fontList: PropTypes.array,
   setSettings: PropTypes.func,
   colors: PropTypes.array,
   onSelectFont: PropTypes.func,
   text: PropTypes.string,
   isMobile: PropTypes.bool,
}
LogoItem.propTypes = {
   settings: PropTypes.object,
   onSelectFont: PropTypes.func,
   text: PropTypes.string,
   item: PropTypes.object,
}


export default IconSvgConvert
